// Four Ball — ported verbatim from GolfGamesScorecard's calcFourBall
// (utils/scoring.ts). 2v2 best-ball match: each team's low ball per hole; the
// lower best ball wins the hole, most holes wins the match.
export function calcFourBall(team1, team2) {
  const holeResults = Array.from({ length: 18 }, (_, hole) => {
    const t1Best = Math.min(...team1.map((p) => p.scores[hole] ?? 999))
    const t2Best = Math.min(...team2.map((p) => p.scores[hole] ?? 999))
    if (t1Best < t2Best) return 'team1'
    if (t2Best < t1Best) return 'team2'
    return 'halved'
  })
  const t1Holes = holeResults.filter((r) => r === 'team1').length
  const t2Holes = holeResults.filter((r) => r === 'team2').length
  return { holeResults, t1Holes, t2Holes, winner: t1Holes > t2Holes ? 'Team 1' : t2Holes > t1Holes ? 'Team 2' : 'Tied' }
}
